/* MaxxAlive product landing template (product.dailymaxx). Self-contained; does not modify ma-home.js. */
(function () {
  if (window.__maPdpLoaded) return;
  window.__maPdpLoaded = true;

  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  /* ---------- Money ---------- */
  function formatMoney(cents) {
    var fmt = (window.theme && window.theme.moneyFormat) || '${{amount}}';
    var value = (cents / 100);
    function withDelims(n, decimals, thousands, dec) {
      var parts = n.toFixed(decimals).split('.');
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousands);
      return parts.join(dec);
    }
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/, function (_, key) {
      switch (key) {
        case 'amount_no_decimals': return withDelims(value, 0, ',', '.');
        case 'amount_with_comma_separator': return withDelims(value, 2, '.', ',');
        case 'amount_no_decimals_with_comma_separator': return withDelims(value, 0, '.', ',');
        default: return withDelims(value, 2, ',', '.');
      }
    });
  }

  /* ---------- Toast + header cart count (same look as the homepage) ---------- */
  var toastEl, toastTimer;
  function esc(s) { return String(s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function toast(html, isError) {
    if (!toastEl) {
      toastEl = document.createElement('div');
      toastEl.className = 'ma-toast';
      toastEl.setAttribute('role', 'status');
      toastEl.setAttribute('aria-live', 'polite');
      document.body.appendChild(toastEl);
    }
    toastEl.innerHTML = html;
    toastEl.classList.toggle('is-error', !!isError);
    toastEl.classList.add('is-visible');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { toastEl.classList.remove('is-visible'); }, 3500);
  }
  function updateCartCount() {
    return fetch(root + 'cart.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); }).then(function (cart) {
      var count = cart.item_count, bubble = document.getElementById('CartCount');
      if (!bubble) {
        var link = document.querySelector('.site-header__cart');
        if (!link) return;
        bubble = document.createElement('div');
        bubble.id = 'CartCount';
        bubble.className = 'site-header__cart-count';
        bubble.innerHTML = '<span></span><span class="icon__fallback-text medium-up--hide"></span>';
        link.appendChild(bubble);
      }
      var spans = bubble.querySelectorAll('span');
      if (spans[0]) spans[0].textContent = count;
      if (spans[1]) spans[1].textContent = count + (count === 1 ? ' item' : ' items');
      bubble.classList.toggle('hide', count === 0);
    }).catch(function () {});
  }

  /* ---------- Buy box ---------- */
  function initBuy(box) {
    if (box.__maInit) return;
    box.__maInit = true;
    var jsonEl = box.querySelector('[data-ma-pdp-json]');
    if (!jsonEl) return;
    var data = JSON.parse(jsonEl.textContent);
    var labels = data.labels;
    var state = {
      variantId: data.initialVariant,
      mode: data.defaultMode,
      planId: data.plans.length ? data.plans[0].id : null,
      qty: 1
    };
    var addBtn = box.querySelector('[data-ma-pdp-add]');
    var qtyInput = box.querySelector('[data-ma-qty]');

    function variant() {
      for (var i = 0; i < data.variants.length; i++) if (data.variants[i].id === state.variantId) return data.variants[i];
      return data.variants[0];
    }
    function subPrice(v) {
      var p = v.plans[String(state.planId)];
      return typeof p === 'number' ? p : null;
    }
    function unitPrice(v) {
      if (state.mode === 'sub') { var s = subPrice(v); if (s !== null) return s; }
      return v.price;
    }
    function setText(sel, txt) { document.querySelectorAll(sel).forEach(function (el) { el.textContent = txt; }); }

    function render() {
      var v = variant(), sp = subPrice(v), unit = unitPrice(v), total = unit * state.qty;
      box.querySelectorAll('[data-ma-opt]').forEach(function (opt) {
        var on = opt.getAttribute('data-ma-opt') === state.mode;
        opt.classList.toggle('is-selected', on);
        var r = opt.querySelector('.ma-opt__radio'); if (r) r.checked = on;
      });
      if (sp !== null) {
        setText('[data-ma-sub-price]', formatMoney(sp));
        setText('[data-ma-sub-was]', formatMoney(v.price));
        var pct = Math.round((1 - sp / v.price) * 100);
        box.querySelectorAll('[data-ma-sub-name]').forEach(function (el) { el.textContent = labels.subName.replace('{percent}', pct); });
      }
      setText('[data-ma-once-price]', formatMoney(v.price));

      var available = v.available;
      addBtn.disabled = !available;
      var label = !available ? labels.soldOut : (state.mode === 'sub' ? labels.subCta : labels.onceCta).replace('{price}', formatMoney(total));
      addBtn.textContent = label;
      setText('[data-ma-pdp-cta-label]', label);
      document.querySelectorAll('[data-ma-pdp-trigger]').forEach(function (b) { b.disabled = !available; });

      var savings = box.querySelector('[data-ma-savings]');
      if (savings) {
        var show = state.mode === 'sub' && sp !== null && sp < v.price;
        savings.hidden = !show;
        if (show) savings.textContent = labels.savings.replace('{amount}', formatMoney((v.price - sp) * state.qty));
      }
      setText('[data-ma-sticky-price]', state.mode === 'sub' && sp !== null
        ? labels.stickySub.replace('{price}', formatMoney(sp))
        : labels.stickyOnce.replace('{price}', formatMoney(v.price)));
      if (qtyInput) qtyInput.value = state.qty;

      /* Keep the URL's ?variant= in sync like Debut does, without reloading. */
      if (data.variants.length > 1 && window.history && history.replaceState) {
        history.replaceState({}, '', location.pathname + '?variant=' + state.variantId);
      }
    }

    box.addEventListener('change', function (e) {
      var t = e.target;
      if (t.matches('.ma-opt__radio')) state.mode = t.value;
      if (t.matches('[data-ma-plan]')) { state.planId = Number(t.value); state.mode = 'sub'; }
      if (t.matches('[data-ma-variant]')) state.variantId = Number(t.value);
      if (t.matches('[data-ma-qty]')) state.qty = Math.max(1, Math.min(99, parseInt(t.value, 10) || 1));
      render();
    });
    box.addEventListener('click', function (e) {
      var step = e.target.closest('[data-ma-step]');
      if (step) { state.qty = Math.max(1, Math.min(99, state.qty + Number(step.getAttribute('data-ma-step')))); render(); }
      var thumb = e.target.closest('[data-ma-thumb]');
      if (thumb) {
        var idx = thumb.getAttribute('data-ma-thumb');
        box.querySelectorAll('[data-ma-slide]').forEach(function (s) { s.hidden = s.getAttribute('data-ma-slide') !== idx; });
        box.querySelectorAll('[data-ma-thumb]').forEach(function (t) { t.setAttribute('aria-current', t === thumb ? 'true' : 'false'); });
      }
    });

    addBtn.addEventListener('click', function () {
      if (addBtn.disabled || addBtn.classList.contains('is-loading')) return;
      var item = { id: state.variantId, quantity: state.qty };
      if (state.mode === 'sub' && state.planId) item.selling_plan = state.planId;
      var original = addBtn.textContent;
      addBtn.classList.add('is-loading');
      addBtn.setAttribute('aria-busy', 'true');
      fetch(root + 'cart/add.js', {
        method: 'POST', credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [item] })
      }).then(function (r) {
        return r.json().then(function (d) { if (!r.ok) throw new Error(d.description || d.message || 'This item could not be added.'); return d; });
      }).then(function () {
        var planName = '';
        if (item.selling_plan) data.plans.forEach(function (p) { if (p.id === item.selling_plan) planName = ' (' + p.name + ')'; });
        toast('\u2713 Added to cart \u00b7 ' + state.qty + ' \u00d7 ' + esc(data.title + planName) +
          '<a href="' + root + 'cart">View cart</a>');
        return updateCartCount();
      }).catch(function (err) {
        toast(esc(err.message) + ' <a href="' + root + 'cart">Go to cart</a>', true);
      }).then(function () {
        addBtn.classList.remove('is-loading');
        addBtn.removeAttribute('aria-busy');
        addBtn.textContent = original;
      });
    });

    box.__maChoose = function (mode) { if (mode === 'once' || data.plans.length) { state.mode = mode; render(); } };
    box.__maAddBtn = addBtn;
    render();
    watchSticky(addBtn);
  }

  /* "Start my subscription" / "or buy once" (guarantee band) and the sticky bar button */
  document.addEventListener('click', function (e) {
    var box = document.querySelector('[data-ma-pdp]');
    var choose = e.target.closest('[data-ma-pdp-choose]');
    if (choose && box && box.__maChoose) {
      e.preventDefault();
      box.__maChoose(choose.getAttribute('data-ma-pdp-choose'));
      box.scrollIntoView({ behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'start' });
    }
    var trigger = e.target.closest('[data-ma-pdp-trigger]');
    if (trigger && box && box.__maAddBtn) { e.preventDefault(); box.__maAddBtn.click(); }
  });

  /* ---------- Sticky bar: shows once the main Add to Cart button scrolls out of view ---------- */
  var mainBtnVisible = true, observer;
  function watchSticky(btn) {
    if (!('IntersectionObserver' in window)) return;
    if (observer) observer.disconnect();
    observer = new IntersectionObserver(function (entries) {
      mainBtnVisible = entries[0].isIntersecting;
      updateSticky();
    });
    observer.observe(btn);
  }
  function updateSticky() {
    document.querySelectorAll('[data-ma-pdp-sticky]').forEach(function (bar) {
      var nearBottom = window.innerHeight + window.scrollY >= document.documentElement.scrollHeight - 200;
      var btn = document.querySelector('[data-ma-pdp-add]');
      var below = btn && btn.getBoundingClientRect().bottom < 0; /* only after scrolling past it, not before */
      var show = !mainBtnVisible && below && !nearBottom;
      bar.classList.toggle('is-visible', show);
      bar.setAttribute('aria-hidden', show ? 'false' : 'true');
    });
  }
  var ticking = false;
  window.addEventListener('scroll', function () { if (!ticking) { ticking = true; requestAnimationFrame(function () { ticking = false; updateSticky(); }); } }, { passive: true });

  /* ---------- FAQ: one item open at a time ---------- */
  document.addEventListener('toggle', function (e) {
    var d = e.target;
    if (!d.matches || !d.matches('[data-ma-faq] details') || !d.open) return;
    d.closest('[data-ma-faq]').querySelectorAll('details[open]').forEach(function (o) { if (o !== d) o.open = false; });
  }, true);

  function initAll() { document.querySelectorAll('[data-ma-pdp]').forEach(initBuy); updateSticky(); }
  document.addEventListener('shopify:section:load', function () { document.querySelectorAll('[data-ma-pdp]').forEach(function (b) { b.__maInit = false; }); initAll(); });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll); else initAll();
})();
